<template lang="pug">
  div
    .filters(v-if="isAdmin && (animalTypes.length || showDeleted)")
      v-switch(
        :label="$t('base.show_deleted')"
        v-model="showDeleted")

    template(v-if="loaded")
      v-card.mb-2(
        v-for="item in animalTypes"
        :key="item.id"
        :class="{ 'card--deleted': item.deleted }")
        .list-mobile
          .list-mobile__top
            .list-mobile__title.list-mobile__title--size-lg 
              span {{ item.name | shortstr }}
              .type-badge.type-badge--deleted(v-if="item.deleted") {{ 'base.deleted' | translate }}
            .list-mobile__button
              v-btn(
                v-if="!item.deleted"
                :disabled="!hasPermission('animal_type', 'change')"
                icon
                @click="selectAnimalType(item.id)")
                v-icon(
                  font-size="1"
                  icon="cog")
          .list-mobile__content
            .list-mobile__item
              .list-mobile__item-label {{ 'base.animal_count' | translate }}
              .list-mobile__item-value {{ item.animal_count || 0 }}

      v-table-body(
        v-if="loaded"
        outsideTable
        :empty="!animalTypes.length")

    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 1" :key="`${i}-${j}`")
              .list-mobile__item-skeleton
              .list-mobile__item-skeleton

    template(v-if="loaded && animalTypes.length")
      ui-pagination(
        v-model="page"
        offset-none
        :count="count"
        @page-change="loadData")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'

export default {
  name: 'TypesTableMobile',

  components: {
    UiPagination
  },

  data: () => ({
    page: 1,
    loaded: false,
    showDeleted: false,
    userType: null
  }),

  async created () {
    try {
      const { data } = await api.account.get()
      this.userType = data.user_type
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },

  computed: {
    ...mapGetters('animaltypes', [
      'animalTypes',
      'count'
    ]),

    isAdmin () {
      return this.userType === 'admin'
    }
  },

  mounted () {
    this.loadData()
  },

  watch: {
    page () {
      this.loaded = false
    },

    async showDeleted () {
      this.loaded = false
      this.page = 1
      await this.loadData()
    }
  },

  methods: {
    ...mapActions('animaltypes', [
      'loadAnimalTypes',
      'selectAnimalType'
    ]),

    async loadData () {
      const filters = {
        farm: this.$route.params.farm_id,
        page: this.page > 1 ? this.page : null
      }

      if (!this.isAdmin) {
        filters.deleted = false
      } else {
        filters.deleted = this.showDeleted
      }

      await this.loadAnimalTypes(filters)
      this.loaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.filters {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
  padding: 0 1.6rem;
  
  ::v-deep .v-switch {
    &__label {
      font-size: 1.4rem;
      font-weight: 500;
      color: #666;
    }
  }
}

.card--deleted {
  background: #ffebee;
  opacity: 0.7;

  .list-mobile__title {
    color: #c62828;
  }
}

.type-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  vertical-align: middle;

  &--deleted {
    background: #c62828;
    color: #fff;
    margin-left: 4px;
  }
}
</style>